import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {DispatchProfilePage, type DispatchProfileTab, OtsInlineAlert} from "@ots-frontend/ots-ui-tw";

/** `/dispatch/profile?id=`: the shared Tailwind dispatch profile, with DispatchGo's routes for its actions. */
export const DispatchProfilePageRoute = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const state = useLocation().state as {tabValue?: DispatchProfileTab} | null;
  const id = params.get("id");

  if (!id) {
    return <OtsInlineAlert tone="warning" title="No dispatch selected" className="m-6">
      Open a dispatch from the board to see its profile.
    </OtsInlineAlert>;
  }

  return (
    <DispatchProfilePage
      key={id}
      id={id}
      initialTab={state?.tabValue}
      onEdit={(dispatch) => navigate("/dispatch/form", {state: {id: dispatch.id}})}
      onOpenTicket={(pickupId, deliveryId) => navigate(`/tickets/profile?pid=${pickupId}&did=${deliveryId}`)}
      onOpenRequest={(requestId) => navigate(`/requests/profile?id=${requestId}`)}
      onOpenDispatch={(dispatchId) => navigate(`/dispatch/profile?id=${dispatchId}`)}
      onDeleted={() => navigate("/dispatch", {replace: true})}/>
  );
};
